import React, {
  useMemo,
} from 'react';
import PropTypes from 'prop-types';

export default function VideoPreview({
  url,
  file,
}) {
  const src = useMemo(() => {
    if (url) return url;
    return file instanceof File ? URL.createObjectURL(file) : null;
  }, [url, file]);

  return (
    <div
      className="pdf-container basic-pdf"
      style={{
        display: 'block',
        paddingTop: 25,
        height: 'calc(100% - 100px)',
      }}
    >

      <div
        style={{
          width: '100%',
          height: '100%',
          marginLeft: 'auto',
          marginRight: 'auto',
        }}
      >
        <video
          key={url}
          className="full-photo"
          src={src}
          alt="Full Page"
          controls
          style={{
            width: '100%',
            height: '100%',
            maxWidth: 'unset',
            maxHeight: 'unset',
            objectFit: 'contain',
            backgroundColor: 'black',
            marginTop: 0,
          }}
        >
          <track kind="captions" />
        </video>
      </div>
    </div>
  );
}

VideoPreview.propTypes = {
  url: PropTypes.string,
  file: PropTypes.instanceOf(File),
};

VideoPreview.defaultProps = {
  url: undefined,
  file: undefined,
};
